import React, { useEffect, useRef, useState } from 'react'

import { Tab } from '@headlessui/react';
// import Grid from "../../../../assets/images/grid.png"
import { About } from './about';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {GetIndustry, GetLocation, GetProjectCategories, GetRole, GetSkills} from '../../../service/commonapi';
// import { GetAwards } from '../../service/talent-onboardig-api';
import { useDispatch, useSelector } from 'react-redux';
import { ProfileImage } from '../../common/profile-image';
import { Matchingprojects } from './matching-projects';
import {InlineWidget} from "react-calendly";
import {roleLabelById} from "../../../../utils/roles";
import {useGetRoleQuery} from "../../../../store/api/api";
import Modal from "../../common/Modal";
import PublicAgencyProfile from "../../agency/profile";


export const AgencyMatchingSummary = (props) => {
    const navigate = useNavigate();
    const calendly = useRef(null)
    var {data: rolesData , error: rolesErr, isLoading: rolesIsLoading } = useGetRoleQuery();

    const sortArray = (arr1, arr2) => {
        arr2.sort((a, b) => {
           const aKey = (a.id);
           const bKey = (b.id);
           //console.log(arr1.findIndex((obj) => obj.agency_id === aKey))
           return arr1.findIndex((obj) => obj.agency_id === aKey) - arr1.findIndex((obj) => obj.agency_id === bKey);
        });
     };
    useEffect(()=>{
        sortArray(props.userDetails,props.results.data);
        // console.log(props.results)
        // console.log(props.userDetails)
    },[])

    var { platform, uid } = useParams();
    const location = useLocation();
    const selectStore = useSelector(state => state.selectStore);
    // const talentStore = useSelector(state => state.talentStore);
    // const agencyStore = useSelector(state => state.agencyStore);
    // const commonStore = useSelector(state => state.commonStore);
    const [urlPlatform, setUrlPlatform] = useState(location.pathname.split('/')[2])
    // const talentProfileStore = useSelector(state => state.talentProfileStore);
    // const agencyProfileStore = useSelector(state => state.agencyProfileStore);
    // const [showloader, setshowloader] = useState(false);
    const [selectedIndex, setselectedIndex] = useState(props.defaultTab);
    const [showCalendly, setShowCalendly] = useState(false);
    const [showAgency, setShowAgency] = useState();
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    const isMounted = useRef(true);
    // const [currentDetails, setCurrentDetails] = useState()

    useEffect(() => {
        if (isMounted.current || !uid) {
            // setshowloader(true)
           // doesSessionExist();
            setUrlPlatform(location.pathname.split('/')[2])
            callAllSelect();
        }
    }, [uid]);



/** checks whether the session exista */
// async function doesSessionExist() {
//     if (await Session.doesSessionExist()) {
//     } else {
//         navigate("/login");
//     }
// }


    function onFullProfileClick(agency) {
        //console.log(agency)
        setShowAgency(agency)
    }

/** loads all API */
function callAllSelect() {
    try {
        // if (!uid || ( (commonStore.platform === 'agency' && agencyStore.page1.email === "" ) ||( commonStore.platform === 'talent' &&talentStore.page1.email === ""))) {
        //     console.log("callAllSelect")
        //     CheckLogin(dispatch, talentStore, agencyStore, commonStore, talentProfileStore, agencyProfileStore).then((response) => {
        //         if(!uid){
        //             if (response.platform === "agency") {
        //                 // navigate("/agency-profile?" + common.encryptdecrypt("encrypt", response.agency_id));
        //                 dispatch({ type: 'common_details/insertValue', payload: { "id": { "id": response.agency_id, "platform": "agency" }, "name": "activeProfile" } });
        //             } else {
        //                 // navigate(`/talent-profile?${common.encryptdecrypt("encrypt", response.talent_id)}`)
        //                 dispatch({ type: 'common_details/insertValue', payload: { "id": { "id": response.talent_id, "platform": "talent" }, "name": "activeProfile" } });
        //             }
        //         }
        //      })
        // }
        GetRole(dispatch, selectStore)
        GetSkills(dispatch, selectStore)
        GetIndustry(dispatch, selectStore)
        GetLocation(dispatch, selectStore)
    // GetAwards(dispatch, selectStore)
        GetProjectCategories(dispatch, selectStore)
        // setshowloader(false)
    } catch (err) { 
        // setshowloader(false); 
        console.log(err) }
}

useEffect(()=>{
    setselectedIndex(props.defaultTab)
},[props.defaultTab])

function tabHandler(index){
    setselectedIndex(index);
    if(platform === "agency"){
        [...document.querySelectorAll(".test")].forEach(_node => {
            _node.classList.remove("active-card-agency")
        })
        document.querySelectorAll(`.cards-${index}`)[0].children[1].classList.add("active-card-agency")
    }else{
        [...document.querySelectorAll(".test")].forEach(_node => {
            _node.classList.remove("active-card")
        })
        document.querySelectorAll(`.cards-${index}`)[0].children[1].classList.add("active-card")
    }

}

function getLeadersNames(data) {
    var index = props.userDetails.findIndex((val) => val.agency_id === data.id);
    if(index !== -1) {
        var val = props.userDetails[index];
        return val.leaders[0].fullname && val.leaders[1].fullname ? val.leaders[0].fullname.split(' ')[0] + ", " + val.leaders[1].fullname.split(' ')[0]:'Agency Leaders';
    }

    return "Agency leaders"
}

function getLeadersData(data, i, isImage) {
    var index = props.userDetails.findIndex((val) => val.agency_id === data.id);
    if(index !== -1) {
        var val = props.userDetails[index];
        // setCurrentDetails(val)
        if(val && val.leaders && val.leaders.length && val.leaders[i]) {
            if(isImage) {
                return val.leaders[i].profile_avatar_url ? val.leaders[i].profile_avatar_url : "data:image/png;base64,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"
            }
            return val.leaders[i].fullname ? val.leaders[i].fullname : 'Name'
        } else {
            if(isImage) {
                return null
            }
            return 'Name'
        }
    } else {
        if(isImage) {
            return "data:image/png;base64,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"
        }
        return 'Name'
    }
    // props.editDetails && props.editDetails.leaders && props.editDetails.leaders.length && props.editDetails.leaders[0]? props.editDetails.leaders[0].fullname : 'Your Name'
}

    function getLeadersRoleLabel(data, i) {
        var index = props.userDetails.findIndex((val) => val.agency_id === data.id);
        if(index !== -1) {
            var val = props.userDetails[index];
            // setCurrentDetails(val)
            if(val && val.leaders && val.leaders.length && val.leaders[i]) {

                return val.leaders[i].role ? roleLabelById(rolesData.data,val.leaders[i].role) : 'label1'
            } else {
                return 'label'
            }
        }

        return 'label'
        // props.editDetails && props.editDetails.leaders && props.editDetails.leaders.length && props.editDetails.leaders[0]? props.editDetails.leaders[0].fullname : 'Your Name'
    }

    function getCommaSeparator(dd) {
        if(dd && dd !== "") {
        let val = dd.toString().replaceAll(',', '');
        val = val.replaceAll('$', '');
        var _val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return _val
        }
    }

  return (
    <div className='bg-[#f5f5f5] w-full'>
        <div className='h-full'>
            <div className='max-w-[1088px] [@media(max-width:1023px)]:!max-w-[80%] m-auto'>
            <Tab.Group selectedIndex={selectedIndex} onChange={(index) => tabHandler(index)} as={"div"} className="tab-list">
                <Tab.List>
                    {props.userDetails.map((_data) => {
                        return(
                            <Tab>{_data.name}</Tab>
                        )
                    })}
                </Tab.List>
                <Tab.Panels as='div' className='w-full dark:bg-[#0E0E0E] mx-auto bg-white pt-[48px] px-[64px] pb-[88px] [@media(max-width:1023px)]:px-[24px] [@media(max-width:1023px)]:pb-[48px]'>
                    {props.results.data.map((_data) => {
                        console.log("_data",_data)
                        return(
                        <Tab.Panel as='div' className={"w-full"}>
                        <div className='w-full'>
                            <div className='flex gap-[62px]'>
                            <div className=''>
                                <img className='w-[158px] h-[141px]' src={_data.photo_url?_data.photo_url:"../../images/defLogo.svg"} alt="logo"></img>
                            </div>
                            <div className='flex flex-col justify-center gap-[16px]'>
                                <p className='text-[88px] tracking-[-2.64px] font-medium leading-[100%] capitalize text-[#0E0E0E]'>{_data.name}</p>
                                <p className='text-[24px] tracking-[-0.72px] pl-[5px] leading-[100%] font-normal text-[#0E0E0E]'>{_data.heading}</p>
                            </div>
                            </div>
                            <div className='grid grid-cols-2 w-full mt-[88px]'>
                                <div>
                                <span className='text-[19.942px] text-[#0E0E0E] leading-[100%] tracking-[-0.598px] capitalize'>Match Rating</span>
                                <div className='flex gap-[5px] items-center mt-[10px]'>
                                    <div className="content w-full">
                                        <section className='loading flex flex-row gap-[16px] w-full !p-0'>    
                                            <div className="progress !mb-[0px]">
                                                <span className="progress-bar cool" style={{width:`${(Math.round(_data.match_rate * 100))}%`}}></span>
                                            </div>
                                            <div className='font-bold text-[#0E0E0E] tracking-[-1.44px] leading-[100%] text-[48px] mt-[-15px]'>{(Math.round(_data.match_rate * 100))}%</div> 
                                        </section>
                                    </div>
                                </div>
                                <div className='grid row-[2/3] gap-[32px] pt-[48px] grid-cols-2'>
                                    <div>
                                        <span className='text-[18px] leading-[100%] tracking-[-0.54px] text-[#0E0E0E] capitalize'>Skills and Expertise</span>
                                        <div className='flex gap-[5px] items-center mt-[10px]'>
                                            <div className="content w-full">
                                                <section className='loading flex flex-row gap-[16px] w-full'>    
                                                    <div className="progress !h-[10px] !mb-[0px]">
                                                        <span className="progress-bar cool" style={{width:`${(Math.round(_data.match_rate_skills * 100))}%`}}></span>
                                                    </div>
                                                    <div className='font-normal text-[#0E0E0E] tracking-[-0.96px] leading-[100%] text-[32px] mt-[-11px]'>{(Math.round(_data.match_rate_skills * 100))}%</div> 
                                                </section>
                                            </div>
                                        </div>
                                    </div> 
                                    <div>
                                        <span className='text-[18px] leading-[100%] tracking-[-0.54px] text-[#0E0E0E] capitalize'>Diversity</span>
                                        <div className='flex gap-[5px] items-center mt-[10px]'>
                                            <div className="content w-full">
                                                <section className='loading flex flex-row gap-[16px] w-full'>    
                                                    <div className="progress !h-[10px] !mb-[0px]">
                                                        <span className="progress-bar cool" style={{width:`${(Math.round(_data.match_rate_diversity * 100))}%`}}></span>
                                                    </div>
                                                    <div className='font-normal text-[#0E0E0E] tracking-[-0.96px] leading-[100%] text-[32px] mt-[-11px]'>{(Math.round(_data.match_rate_diversity * 100))}%</div> 
                                                </section>
                                            </div>
                                        </div>
                                    </div> 
                                    <div>
                                        <span className='text-[18px] leading-[100%] tracking-[-0.54px] text-[#0E0E0E] capitalize'>Industry</span>
                                        <div className='flex gap-[5px] items-center mt-[10px]'>
                                            <div className="content w-full">
                                                <section className='loading flex flex-row gap-[16px] w-full'>    
                                                    <div className="progress !h-[10px] !mb-[0px]">
                                                        <span className="progress-bar cool" style={{width:`${(Math.round(_data.match_rate_industry * 100))}%`}}></span>
                                                    </div>
                                                    <div className='font-normal text-[#0E0E0E] tracking-[-0.96px] leading-[100%] text-[32px] mt-[-11px]'>{(Math.round(_data.match_rate_industry * 100))}%</div> 
                                                </section>
                                            </div>
                                        </div>
                                    </div> 
                                    <div>
                                        <span className='text-[18px] leading-[100%] tracking-[-0.54px] text-[#0E0E0E] capitalize'>Brands</span>
                                        <div className='flex gap-[5px] items-center mt-[10px]'>
                                            <div className="content w-full">
                                                <section className='loading flex flex-row gap-[16px] w-full'>    
                                                    <div className="progress !h-[10px] !mb-[0px]">
                                                        <span className="progress-bar cool" style={{width:`${(Math.round(_data.match_rate_brands * 100))}%`}}></span>
                                                    </div>
                                                    {console.log(_data)}
                                                    <div className='font-normal text-[#0E0E0E] tracking-[-0.96px] leading-[100%] text-[32px] mt-[-11px]'>{(Math.round(_data.match_rate_brands * 100))}%</div>
                                                </section>
                                            </div>
                                        </div>
                                    </div> 
                                    {/*<div>*/}
                                    {/*    <span className='text-[18px] leading-[100%] tracking-[-0.54px] text-[#0E0E0E] capitalize'>Target Market</span>*/}
                                    {/*    <div className='flex gap-[5px] items-center mt-[10px]'>*/}
                                    {/*        <div className="content w-full">*/}
                                    {/*            <section className='loading flex flex-row gap-[16px] w-full'>    */}
                                    {/*                <div className="progress !h-[10px] !mb-[0px]">*/}
                                    {/*                    <span className="progress-bar cool" style={{width:`${(Math.round(_data.match_rate_market * 100))}%`}}></span>*/}
                                    {/*                </div>*/}
                                    {/*                <div className='font-normal text-[#0E0E0E] tracking-[-0.96px] leading-[100%] text-[32px] mt-[-11px]'>{(Math.round(_data.match_rate_market * 100))}%</div> */}
                                    {/*            </section>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>      */}
                                    </div>
                                </div>
                                <div className='flex flex-col place-items-end gap-[8px]'>

                                    <div className='flex gap-[24px]'>
                                        <div className="flex flex-col gap-8">
                                            <span className='text-[#808080] dark:text-[#A3A3A3] text-[14px]'>Agency Leaders</span>

                                            <div className='flex gap-[24px]'>

                                            <div className="flex flex-col justify-start w-[200px] gap-[12px]">
                                                <div className="w-[150px] h-[150px]">
                                                    <ProfileImage url={getLeadersData(_data, 0, true)}/>
                                                </div>
                                                <div>
                                                    <div className='font-bold  text-transform: capitalize archivo text-[#1D1D1d] text-[24px] dark:text-[#FFFFFF]'>{getLeadersData(_data, 0)}</div>
                                                   <div className='mb-[16px] text-transform: capitalize archivo text-[#4C4C4C] text-[16px] dark:text-[#FFFFFF]'>{rolesIsLoading ? 'loading...' : getLeadersRoleLabel(_data, 0)}</div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col justify-start w-[200px] gap-[12px]">
                                                <div className="w-[150px] h-[150px]">
                                                    <ProfileImage url={getLeadersData(_data, 1, true)}/>
                                                </div>
                                                <div>
                                                   <div className='font-bold  text-transform: capitalize archivo text-[#1D1D1d] text-[24px] dark:text-[#FFFFFF]'>{getLeadersData(_data, 1)}</div>
                                                   <div className='mb-[16px] text-transform: capitalize archivo text-[#4C4C4C] text-[16px] dark:text-[#FFFFFF]'>{rolesIsLoading ? 'loading...' : getLeadersRoleLabel(_data, 1)}</div>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="w-full flex items-center hover:cursor-pointer" style={{
                                                fontFamily: 'Archivo',
                                                fontSize: '18px',
                                                fontWeight: 600,
                                                lineHeight: '18px',
                                                letterSpacing: '-0.03em',
                                                textAlign: 'left'
                                            }} onClick={() => onFullProfileClick(_data)}>
                                                See Full Profile
                                                <i className="inline-block ml-[3px]">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3 5.05079H11.3591C14.3684 5.05079 16.3189 5.05079 17.2105 5.02381L3 18.327L4.58824 20L18.743 6.69683C18.7152 7.56032 18.7152 9.42222 18.7152 12.3365V19.946L21 17.8952V3H5.00619L3 5.05079Z" fill="black"/>
                                                    </svg>
                                                </i>
                                            </div>
                                        </div>

                                    </div>


                            </div>

                            </div>
                            <hr className='my-[88px]'></hr>
                            <div className='relative'>
                                <About isEdit={props.isEdit}  editDetails={props.userDetails} userDetails={props.userDetails} type={urlPlatform} id={_data.id}/>
                            </div>
                            <div className='relative'>
                                <Matchingprojects name={_data.name} isEdit={props.isEdit}  editDetails={props.userDetails} type={urlPlatform} id={_data.id}/>
                            </div>
                            <hr className='my-[88px]'></hr>
                            <div className='flex justify-between'>
                                <span className='text-[48px] font-bold leading-[91.5%] tracking-[-1.44px]'>Estimated cost</span>
                                {console.log("Estimated cost",_data)}
                                <span className='text-[48px] font-bold leading-[91.5%] tracking-[-1.44px]'>${getCommaSeparator(_data.estimated_weekly_cost*4)}</span>
                            </div>
                            <hr className='my-[88px]'></hr>
                            <div className='flex flex-col items-center text-center gap-[48px]'>
                                <span className='text-[48px] tracking-[-1.44px] leading-[120%]'>{getLeadersNames(_data)} and the team are ready to discuss your brief.</span>
                                <button  onClick={() => {setShowCalendly(true);setTimeout(() => {calendly.current.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                })},500)}} className='!bg-[#F05831] !text-[#fff] border-[1px] text-[16px] px-[24px] rounded-full py-[12px] flex !border-none'>Lets's talk
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M8.51043 7.8055L14.5537 12.6173C14.5537 12.6173 16.8846 10.7613 14.4236 8.80177C13.6623 8.1956 10.5625 5.72742 8.44824 4.04395L8.51043 7.8055Z" fill="white"/>
                                    <path d="M8.51042 17.429L14.5537 12.6172C14.5537 12.6172 16.8846 14.4732 14.4236 16.4328C13.6623 17.0389 10.5625 19.5071 8.44824 21.1906L8.51042 17.429Z" fill="white"/>
                                </svg>
                                </button>
                            </div>

                            {showCalendly && <div className="mt-8" >
                                <InlineWidget url="https://calendly.com/moonshoot?primary_color=bb86fc" />
                            </div>}
                            </div>
                            <div  ref={calendly}>
                            </div>
                        </Tab.Panel> )
                    })}
                </Tab.Panels>
            </Tab.Group>
                <Modal open={showAgency} onClose={() => setShowAgency(null)} url={showAgency ? "/agency/profile/" + showAgency.id:null}><PublicAgencyProfile agencyId={showAgency && showAgency.id}/></Modal>
            </div>
    </div>
</div>
  )
}